users-index
  forms-users-search(tag-scope="forms_users_search")
  users-table(tag-scope="users_table")
  script(type="typescript").
    this.mixin('base');
